module.exports = __webpack_public_path__ + "img/resized-APP-0020-1.3cbd64e3.png";